export function keys(obj: StrictRecord<number, any>) {
  return Object.keys(obj).map(Number);
}
